const URL_PROCEDURE_HISTORY = '/procedure_history';

export const URL_GET_PROCEDURE_HISTORY_LIST = `${URL_PROCEDURE_HISTORY}/query`;
export const URL_ADD_PROCEDURE_HISTORY = `${URL_PROCEDURE_HISTORY}/`;
export const URL_GET_PROCEDURE_HISTORY = `${URL_PROCEDURE_HISTORY}/`;
export const URL_UPDATE_PROCEDURE_HISTORY = `${URL_PROCEDURE_HISTORY}/`;
export const URL_DELETE_PROCEDURE_HISTORY = `${URL_PROCEDURE_HISTORY}/`;
